export default __webpack_public_path__ + "static/Filled_Fish_Basket-3bedaa6504c31d7143330459d5e96f86.png";